// Redux
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// Redux

// Models
import { I_GetSingleUserAccessibleGroupsSendingData } from "../../Models/sendingDataSchema";
// Models

// Services
import { getPossibleAccessibleGroupsForCurrUserService } from "../../Services/Users/get/getPossibleAccessibleGroupsForCurrUserService";
// Services

// Models
import { I_PossibleAccessibleGroupForCurrUser } from "../../Models/interfaces";
import { resetReferenceOfObject } from "../../Utils/resetReferenceOfObject";
// Models

// Utils
import { customizedToast } from "../../Utils/CustomizedToast/customizedToast";
import { reduxCatchHandler } from "../../Utils/ErrorHandlers/reduxCatchHandler";
// Utils

const initialState: I_PossibleAccessibleGroupForCurrUser & {
  isPending: boolean;
  isError: boolean;
} = {
  isPending: false,
  pageNumber: 0,
  pageSize: 0,
  totalPages: 0,
  totalElements: 0,
  hasNextPage: false,
  content: [],
  isError: false,
};

export const getAsyncPossibleAccessibleGroupsForSingle = createAsyncThunk(
  "possibleAccessibleGroupsForSingleUser/getPossibleData",
  async (_data: {
    userToken: string;
    userName: string;
    query: I_GetSingleUserAccessibleGroupsSendingData;
  }) => {
    try {
      const { data } = await getPossibleAccessibleGroupsForCurrUserService(
        _data.userToken,
        _data.userName,
        _data.query
      );

      return data;
    } catch (err: any) {
      reduxCatchHandler(err);
    }
  }
);

export const possibleAccessibleGroupsForSingleUserSlice = createSlice({
  name: "possibleAccessibleGroupsForSingleUser",
  initialState,
  reducers: {
    resetData: (state) => {
      state.content = resetReferenceOfObject(initialState.content);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      getAsyncPossibleAccessibleGroupsForSingle.pending,
      (state) => {
        state.isPending = true;
        state.isError = false;
      }
    );
    builder.addCase(
      getAsyncPossibleAccessibleGroupsForSingle.fulfilled,
      (state, action) => {
        state.isPending = false;
        const err: any = action.payload;

        if (err?.error !== 0) {
          console.log(err);
          for (
            let i: number = 0;
            i <= err?.response.data.messages.length - 1;
            i++
          ) {
            customizedToast(err?.response.data.messages[i].message, "error");
          }
          return;
        } else {
          state.pageNumber = action.payload!.result.pageNumber;
          state.pageSize = action.payload!.result.pageSize;
          state.totalPages = action.payload!.result.totalPages;
          state.totalElements = action.payload!.result.totalElements;
          state.hasNextPage = action.payload!.result.hasNextPage;
          state.content = action.payload!.result.content;
          state.isError = false;
        }
      }
    );
    builder.addCase(
      getAsyncPossibleAccessibleGroupsForSingle.rejected,
      (state, action) => {
        state.isPending = false;
        state.isError = true;
      }
    );
  },
});
